<template>
  <div ref="monitor" class="AutoMonitor"></div>
</template>

<script>
import * as echarts from 'echarts'

const testY = [4, 4.2, 4.4, 4.6, 4.8, 5, 4.7, 4.3, 4.1, 4, 4, 4, 4.0, 4.0]
const testX = [
  '02-01',
  '02-02',
  '02-03',
  '02-04',
  '02-05',
  '02-06',
  '02-07',
  '02-08',
  '02-09',
  '02-10',
  '02-11',
  '02-12',
]
export default {
  data() {
    return {
      myChart: {},
      markLine: {
        standValues: null,
        unit: null,
      },
    }
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.monitor)
  },
  methods: {
    initChart(xdata = testX, ydata = testY, title = '高指', markLine) {
      if (markLine) {
        this.markLine.standValues = markLine.datumLine ? [markLine.datumLine] : []
        this.markLine.unit = markLine.unit
      }
      if (this.myChart) {
        this.myChart.clear()
      }
      const option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'axis',
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //   },
        // ],
        grid: {
          show: true,
          top: '10%',
          left: '2%',
          right: 45,
          bottom: '5%',
          borderWidth: '0',
          containLabel: true,
        },
        yAxis: {
          name: this.markLine.unit || '',
          nameTextStyle: {
            fontSize: 14,
            color: '#8EC0CE',
          },
          show: true,
          type: 'value',
          min: 0,
          // max: 6,
          splitLine: {
            show: true,
            lineStyle: {
              width: 2,
              dashOffset: 10,
              type: 'dashed',
              color: 'rgba(230, 247, 255, 0.2)',
            },
          },
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              fontSize: 14,
              color: '#ffffff',
            },
          },
        },
        xAxis: {
          name: '时间',
          data: xdata,
          nameTextStyle: {
            fontSize: 14,
          },

          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#BAE7FF',
            },
          },
          axisLabel: {
            interval: 0,
            type: 'category',
            formatter: '{value}',
            margin: 20,
            rotate: '45',
            textStyle: {
              fontSize: 14,
              color: '#ffffff',
            },
          },
        },
        series: [
          {
            name: title,
            type: 'line',
            color: '#09CEA5',
            smooth: true, // 关键点，为true是不支持虚线，实线就用true
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2,
                  type: 'solid', // 'dotted'虚线 'solid'实线
                },
              },
            },
            lineWidth: 2,
            symbol: '',
            symbolSize: 0,
            data: ydata,
          },
        ],
      }
      let yMax = 0
      for (let i = 0; i < ydata.length; i += 1) {
        if (ydata[i] >= yMax) {
          yMax = ydata[i]
        }
      }
      if (this.markLine.standValues && this.markLine.standValues.length) {
        const markLineData = []
        this.markLine.standValues.forEach((item) => {
          if (item > yMax) {
            yMax = item
          }
          markLineData.push({
            yAxis: item,
            label: {
              // position: 'insideEndBottom',
              formatter: '标准值',
            },
          })
        })
        option.series[0].markLine = {
          symbol: 'none',
          slient: true,
          symbolSize: 14,
          symbolOffset: [
            [0, -10],
            [0, -10],
          ],
          lineStyle: {
            width: 2,
            color: '#FFD225',
          },
          label: {
            color: '#FFD225',
            fontSize: 14,
          },
          data: markLineData,
        }
      }
      option.yAxis.max = yMax
      this.$nextTick(() => {
        this.myChart.setOption(option)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.AutoMonitor {
  width: 100%;
  height: 27.6rem;
  margin: 0 auto;
}
</style>
